import { render, staticRenderFns } from "./basicTabBar.vue?vue&type=template&id=db4c0248&scoped=true"
import script from "./basicTabBar.vue?vue&type=script&lang=js"
export * from "./basicTabBar.vue?vue&type=script&lang=js"
import style0 from "./basicTabBar.vue?vue&type=style&index=0&id=db4c0248&prod&lang=scss&scoped=true"
import style1 from "./basicTabBar.vue?vue&type=style&index=1&id=db4c0248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4c0248",
  null
  
)

export default component.exports